import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Typography, Box } from '@mui/material';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

import Accordion from '../../../../../common/components/accordion/Accordion';
import AccordionSummary from '../../../../../common/components/accordion/AccordionSummary';
import NcrActivitiesTabs from './activities/NcrActivitiesTabs';

const NcrActivitiesSectionComponent = () => {
    const { t } = useTranslation();

    const { ncrId } = useParams();

    const [expanded, setExpanded] = useState(true);

    const handleChange = (_event, newExpanded) => {
        setExpanded(newExpanded);
    };

    return (
        <Box style={{ borderRadius: 16 }}>
            <Accordion disableGutters elevation={3} sx={{ width: '100%', padding: '1.5em' }} expanded={expanded} onChange={handleChange}>
                <AccordionSummary>
                    <Typography variant="h6" noWrap component="div">
                        {t('ncrInfo.tabs.activities')}
                    </Typography>
                </AccordionSummary>
                <MuiAccordionDetails sx={{ padding: '1em 0' }}>
                    <NcrActivitiesTabs ncrId={ncrId} />
                </MuiAccordionDetails>
            </Accordion>
        </Box>
    );
};

const NcrActivitiesSection = memo(NcrActivitiesSectionComponent);

export default NcrActivitiesSection;
